import React, { useCallback, useRef, useState, useEffect,useMemo } from "react";
import { connect } from "react-redux";
import RenderSelectBoxCell from "../../../../../common/RenderCell";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring
} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import { Button, SelectBox, TextArea } from 'devextreme-react';
import axios from "axios";
import { confirm } from 'devextreme/ui/dialog';
import data from "../../../../../assets/apiRoutes.json";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../../common/GridLayout";
const ChargesTab = (props) => {
    const gridKey = "5a07e20b-0194-4165-aca3-c2f73e484861";
    const isFormLoadRef = useRef(true);
    const [alloEditingBillAs, setAlloEditingBillAs] = useState(true);
    var url = "wm/TransactionCharge/GetTransactionChargeDetailsByDetailId";
    var updateUrl = "wm/TransactionCharge/UpdateTransactionChargeDetails";
    var insertUrl = "wm/TransactionCharge/AddTransactionChargeDetailsByDetailId";
    var deleteUrl = "wm/TransactionCharge/DeleteTransactionChargeDetails";
    const dataSource = useMemo(() => createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${insertUrl}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${updateUrl}`,
        deleteUrl: `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.sourceId,
                "FormLoad": isFormLoadRef.current,
            };
        }, onUpdated: function (e) {
            isFormLoadRef.current = false;
        },
        onInserted: function (e) {
            isFormLoadRef.current = false;
        }
    }), [props.sourceId]);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    var accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    };
    const deleteRecords = useCallback(() => {
        var deleteUrl = "wm/TransactionCharge/DeleteTransactionChargeDetails";
        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                props.transactionChargesGrid.current.instance().beginCustomLoading("Deleting");
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                        selectedItemKeys,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        props.transactionChargesGrid.current.instance().endCustomLoading();
                        props.transactionChargesGrid.current.instance().refresh();
                        props.UpdateTotalAmount();
                    })
                    .catch((err) => {
                        props.transactionChargesGrid.current.instance().endCustomLoading();
                    });

            }
        });

    }, [selectedItemKeys]);
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }
    const onEditingStart = (e) => {
        if (e.key != null && e.key != undefined && !props.transactionChargesGrid.current.instance().isRowSelected(e.key)) {
            props.transactionChargesGrid.current.instance().selectRows([e.key], false);
        }
    };
    const onInitNewRow = (e) => {
        if (!e.data.rBilltocustomer) {
            e.data.rBilltocustomer = props.formFields.R_CUSTOMER;
            e.data.identityid = props.formFields.CUSTOMER_NAME;
        }
    };
    const renderCode1Cell = (cellElement) => {
        return (
            <TextArea
                onValueChanged={async (e) => {
                    cellElement.setValue(e.value);
                }}
                label="."
                labelMode='static'
                stylingMode='outlined'

            >
            </TextArea>
        );
    }
    return (
        <div >
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                onContentReady={onContentReady}
                dataSource={dataSource}
                ref={props.transactionChargesGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleCellValueChanged}
                onInitNewRow={onInitNewRow}
                onEditingStart={onEditingStart}
                height='71vh'
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                  <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />

                <Paging enabled={true} defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                    showInfo={true}
                />
                <Editing
                    mode="cell"
                    refreshMode="repaint"
                    allowUpdating={true}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <Column dataField="chargeCode" caption="Charge" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/wm/TransactionCharge/GetChargeDetils`,
                            loadParams: {
                                chargeTypes: function () {
                                    return 'S,I';
                                },
                                headerId: function () {
                                    return props.formFields.ROWID;
                                },
                                detailId: function () {
                                    return props.sourceId;
                                },
                            },
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.rCharge,
                            sort: [{ selector: "name", desc: false }],
                            onValueChangeCallback: async (value, text, additionalData) => {
                                try {
                                   const url = 'wm/TransactionCharge/GetChargeRateDetails';  
                                    const apiUrl = `${window._env_.REACT_APP_APIS}/${url}?headerId=${props.formFields.ROWID}&detailId=${props.sourceId}&chargeId=${value}`;
                                    const response = await axios.get(apiUrl, {
                                        headers: {
                                            access_token: accessToken,  
                                            Authorization: `Bearer ${accessToken}`  
                                        }
                                    });
                                    if (response ) {
                                        const resultValue = response.data;  // The decimal value returned from the API
                                        cellElement.setValue(({ value, text, additionalData, resultValue }));
                                    } else {
                                        console.error('API Error:', response.data.message || 'Unknown error');
                                    }
                                } catch (error) {
                                    console.error('Unexpected Error:', error || error);
                                }
                            },
                        })
                    }
                    setCellValue={ async (rowData, newValue) => {
                        rowData.rCharge = newValue.value;
                        rowData.chargeCode = newValue.text;
                        rowData.description = newValue?.additionalData?.description || '';
                        rowData.rate = newValue?.resultValue?.rate || '';
                        rowData.quantitybillasuom = newValue?.resultValue?.uom || '';
                        rowData.quantitybillas = newValue?.resultValue?.billasquantity || '';
                        rowData.amount = newValue?.resultValue?.amount || '';
                        rowData.chargeuom = newValue?.additionalData?.chargeuom|| '';
                        const billingmethod = newValue?.additionalData?.billingmethod || '';
                        if (billingmethod == "F") {
                            setAlloEditingBillAs(false);
                        }
                        else {
                            setAlloEditingBillAs(true);
                        }

                    }}
                >
                     <RequiredRule message={"Charge is required."}></RequiredRule>
                </Column>
                <Column dataField="description" caption='Description' allowEditing={false} />
                <Column dataField="identityid" caption="Bill To" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetCustomers`,
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.rBilltocustomer,
                            sort: [{ selector: "name", desc: false }],
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.rBilltocustomer = newValue.value;
                        rowData.identityid = newValue.text;
                    }}
                >
                </Column>
                <Column dataField="quantitybillas" caption='Bill As' dataType="number" format="#,##0.00" allowEditing={alloEditingBillAs} />
                <Column dataField="quantitybillasuom" caption="UOM" dataType="string" allowSorting={false}/>
               <Column dataField="chargeuom" caption='Charge UOM' allowEditing={false} />
                <Column dataField="rate" caption='Rate' dataType="number" 
                 format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'USD',
                    useGrouping: true
                }}/>
                <Column dataField="amount" caption='Amount' dataType="number" 
                 format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'USD',
                    useGrouping: true
                }} allowEditing={false} />
                <Column visible={false} dataField="userdefinedcode1" caption="Code1" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMLookup.GetCodes}`,
                            loadParams: {
                                codeType: function () {
                                    return '93';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.userdefinedcode1,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.userdefinedcode1 = newValue.text;
                    }}
                />
                <Column visible={false} dataField="userdefinedreference1" caption="Reference1" dataType="string" editorOptions={{ maxLength: 50 }} allowSorting={false} />
                <Column dataField="userdefinedcomment" visible={false} editCellRender={renderCode1Cell}
                    setCellValue={(rowData, newValue) => {
                        rowData.userdefinedcomment = newValue;
                    }} caption='Comment' >
                </Column>
                <Column dataField="chargetiming" caption='Charge Timing' allowEditing={false}  visible={false} />
                <Column dataField="chargeReleaseDate" caption="Release Date" dataType="datetime" format="MM/dd/yyyy hh:mm aa" allowEditing={false}  visible={false} />
                <Toolbar>
                    <Item
                        name="addRowButton"
                    />
                    <Item location="after">
                        <Button
                            onClick={deleteRecords}
                            icon="trash"
                            disabled={!selectedItemKeys.length}
                        />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={props.transactionChargesGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(ChargesTab);